/* eslint-disable react/prop-types */
import {Card, CardContent, Box, Grid, FormControl, InputLabel, TextField, Typography} from '@deere/fuel-react';

export default function FormContact({
    register, errors
}) {
    return (
        <>
            <Card>
                <CardContent>
                    <Box mt={2}>
                        <Typography
                            component='p'
                            fontWeight='semibold'
                            gutterBottom
                            size='md'
                        >
                            {'Impacted End User'}
                        </Typography>
                        <Grid
                            alignItems='flex-start'
                            container
                            spacing={4}
                        >
                            <Grid
                                item
                                md={2}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                >
                                    <InputLabel htmlFor='impUserId'>
                                        {'User ID'}
                                        <Box
                                            display='inline'
                                            ml={1}
                                        >
                                            <Typography
                                                color='tertiary'
                                                component='span'
                                                size='xs'
                                            >
                                                { '(Optional)' }
                                            </Typography>
                                        </Box>
                                    </InputLabel>
                                    <TextField
                                        fullWidth
                                        id='impUserId'
                                        placeholder='User ID'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={5}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='impFirstName'>{'First Name'}</InputLabel>
                                    <TextField
                                        {...register('impactedUserFirstName')}
                                        error={errors.impactedUserFirstName?.message}
                                        fullWidth
                                        helperText={errors.impactedUserFirstName?.message}
                                        id='impFirstName'
                                        placeholder='First Name'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={1}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='impMiddleInit'>{'M Init'}</InputLabel>
                                    <TextField
                                        {...register('impactedUserMiddleInit')}
                                        error={errors.impactedUserMiddleInit?.message}
                                        fullWidth
                                        helperText={errors.impactedUserMiddleInit?.message}
                                        id='impactedUserMiddleInit'
                                        inputProps={{
                                            maxLength: 1,
                                            style: {
                                                textAlign: 'center'
                                            }
                                        }}
                                        placeholder='M Init'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={4}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='impLastName'>{'Last Name'}</InputLabel>
                                    <TextField
                                        {...register('impactedUserLastName')}
                                        error={errors.impactedUserLastName?.message}
                                        fullWidth
                                        helperText={errors.impactedUserLastName?.message}
                                        id='impLastName'
                                        placeholder='Last Name'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='impJobTitle'>{'Job Title'}</InputLabel>
                                    <TextField
                                        {...register('impactedUserJobTitle')}
                                        error={errors.impactedUserJobTitle?.message}
                                        fullWidth
                                        helperText={errors.impactedUserJobTitle?.message}
                                        id='impJobTitle'
                                        placeholder='Job Title'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='impEmail'>{'Email'}</InputLabel>
                                    <TextField
                                        {...register('impactedUserEmail')}
                                        error={errors.impactedUserEmail?.message}
                                        fullWidth
                                        helperText={errors.impactedUserEmail?.message}
                                        id='impEmail'
                                        placeholder='Email'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={4}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='impSupplierNumber'>
                                        {'Supplier Number'}
                                    </InputLabel>
                                    <TextField
                                        {...register('impactedSupplierNumber')}
                                        error={errors.impactedSupplierNumber?.message}
                                        fullWidth
                                        helperText={errors.impactedSupplierNumber?.message}
                                        id='impSupplierNumber'
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                md={8}
                                xs={12}
                            >
                                <FormControl
                                    fullWidth
                                    required={true}
                                >
                                    <InputLabel htmlFor='impSupplierName'>
                                        {'Supplier Name'}
                                    </InputLabel>
                                    <TextField
                                        {...register('impactedSupplierName')}
                                        error={errors.impactedSupplierName?.message}
                                        fullWidth
                                        helperText={errors.impactedSupplierName?.message}
                                        id='impSupplierName'
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Box>
                </CardContent>
            </Card>
        </>
    );
}
